import { isInColumnList } from '../../common/inList/inListUtils';

type GetShouldSetContentVisibilityArgs = {
    allowElementPlaceholder: boolean;
    isBatchedRenderInProgress: boolean;
    isSafari: boolean;
    inList?: string | null;
};

export const getShouldSetContentVisibility = ({
    allowElementPlaceholder,
    isBatchedRenderInProgress,
    isSafari,
    inList,
}: GetShouldSetContentVisibilityArgs) =>
    !allowElementPlaceholder && !isBatchedRenderInProgress && !(isSafari && isInColumnList(inList));
